import {styled} from '@mui/material/styles'
import MuiAlert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export const StyledFAQSectionText = styled('div')(({theme}) => ({
  ...theme.typography.body2,
  color: theme.palette.text.primary,
  marginTop: theme.spacing(1)
}))
export const StyledPopupContainer = styled(Box)(({open}) => ({
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 0,
  width: '100%',
  zIndex: 1400,
  display: 'flex',
  justifyContent: 'center',
  pointerEvents: open ? 'auto' : 'none',
  transform: open ? 'translateY(0)' : 'translateY(100%)',
  opacity: open ? 1 : 0,
  transition: 'transform 1.5s cubic-bezier(0.4,0,0.2,1), opacity 1.5s cubic-bezier(0.4,0,0.2,1)',
  willChange: 'transform, opacity'
}))

export const StyledFAQLink = styled('a')(({theme}) => ({
  color: theme.palette.primary.main,
  fontWeight: theme.typography.fontWeightMedium,
  textDecoration: 'underline'
}))
export const StyledPercentagePopupImg = styled('img')(({theme}) => ({
  marginTop: theme.spacing(1),
  width: 64,
  height: 64
}))

export const StyledDataTitle = styled(Typography)(({theme}) => ({
  marginBottom: theme.spacing(0.5),
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.text.primary,
  fontSize: theme.typography.subtitle1.fontSize
}))

export const StyledDataDescription = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.fontWeightRegular,
  color: theme.palette.text.primary,
  marginLeft: theme.spacing(0.5),
  fontSize: theme.typography.subtitle1.fontSize
}))

export const MainBoxPopupWrapper = styled('div')(({theme}) => ({
  width: '100%',
  margin: 0,
  paddingLeft: theme.spacing(8),
  paddingRight: theme.spacing(0),
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center'
}))

export const StyledAlert = styled(MuiAlert)(({theme}) => ({
  width: '100%',
  background: theme.palette.warning.light,
  color: theme.palette.text.primary,
  alignItems: 'flex-start',
  boxShadow: theme.shadows[2],
  border: `1px solid ${theme.palette.divider}`,
  minWidth: 0,
  maxWidth: '100%',
  fontWeight: theme.typography.fontWeightRegular,
  borderRadius: 0
}))

export const IconBox = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'none',
  marginRight: theme.spacing(2)
}))

export const ContentRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start'
}))

export const ContentCol = styled(Box)(() => ({
  flex: 1
}))
